import React, { FC, useEffect, useState } from 'react'
import axios from 'axios'
import Box from '@components/Box'
import { SButtonTabAero } from '@components/Questions/styled'
import QuestionsList from '@components/Questions/QuestionsList'
import { ITab } from '@components/Questions/types'

const Questions: FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0)
  const [tabs, setTabs] = useState<ITab[]>([])

  useEffect(() => {
    axios
      .get('/faq/', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        params: { code: 'aeroflot' },
      })
      .then(({ data }: any) => {
        const tabs: ITab[] = []

        for (const dataKey in data) {
          const tab: ITab = {
            title: data[dataKey]['0']['NAME'],
            sort: parseInt(data[dataKey]['0']['SORT']),
            content: [],
          }

          for (const key in data[dataKey]) {
            tab.content.push({
              title: data[dataKey][key]['ELEMENTS_NAME'],
              sort: parseInt(data[dataKey][key]['ELEMENTS_SORT']),
              content: data[dataKey][key]['ELEMENTS_PREVIEW_TEXT'],
            })
          }

          tab.content.sort((a, b) => a.sort - b.sort)
          tabs.push(tab)
        }

        setTabs(tabs.sort((a, b) => a.sort - b.sort))
      })
  }, [])

  return (
    <>
      {tabs.length ? (
        <Box>
          <Box overflowX="auto">
            <Box display="flex" mb={{ _: '40px', xl: '32px' }}>
              {tabs.map((tab, index) => (
                <SButtonTabAero
                  onClick={() => setActiveTab(index)}
                  key={index}
                  active={+(index === activeTab)}
                  ml="4px"
                >
                  {tab.title}
                </SButtonTabAero>
              ))}
            </Box>
          </Box>
          <QuestionsList data={tabs[activeTab].content} />
        </Box>
      ) : (
        <>Загрузка</>
      )}
    </>
  )
}

export default Questions
